import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 20000 });

export const postFindLead = (data) => api.post("/leads/find", data).then(r => r.data);
export const postSellLead = (data) => api.post("/leads/sell-trade", data).then(r => r.data);
export const getBudgetGuidance = (data) => api.post("/budget-guidance", data).then(r => r.data);
export const postTradeEstimate = (data) => api.post("/trade-estimate", data).then(r => r.data);
export const getRecentlySourced = () => api.get("/recently-sourced").then(r => r.data);
export const getSuccessStories = () => api.get("/success-stories").then(r => r.data);
export const CHAT_URL = `${API}/concierge/chat`;
